import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Toggle } from '@welldev-group/react-comp-lib';
import Tooltip from '@welldev-group/rcl-tooltip';

const SubscriptionModeSwitch = ({
  subscribeYearly,
  onModeChange,
  flippedHorizontaly,
  disabled,
  disabilityReasonText,
}) => {
  return (
    <div
      className={classNames('subscription-mode-switch', {
        'subscription-mode-switch--flipped-horizontaly': flippedHorizontaly,
      })}
    >
      {disabled && disabilityReasonText ? (
        <Tooltip content={disabilityReasonText}>
          <Toggle
            className="subscription-mode-switch__toggle"
            isChecked={subscribeYearly}
            size="tiny"
            onChange={onModeChange}
            disabled={disabled}
          />
        </Tooltip>
      ) : (
        <Toggle
          className="subscription-mode-switch__toggle"
          isChecked={subscribeYearly}
          size="tiny"
          onChange={onModeChange}
          disabled={disabled}
        />
      )}
      <span className="subscription-mode-switch__helper-text">
        <strong>{I18n.t('components.pricing.plans.subscription_mode_switch_text_focused')}</strong>
        <span>{I18n.t('components.pricing.plans.subscription_mode_switch_text')}</span>
      </span>
    </div>
  );
};

SubscriptionModeSwitch.defaultProps = {
  flippedHorizontaly: false,
  subscribeYearly: false,
  onModeChange: () => {},
  disabled: false,
  disabilityReasonText: '',
};

SubscriptionModeSwitch.propTypes = {
  flippedHorizontaly: PropTypes.bool,
  subscribeYearly: PropTypes.bool,
  onModeChange: PropTypes.func,
  disabled: PropTypes.bool,
  disabilityReasonText: PropTypes.string,
};

export default SubscriptionModeSwitch;
